const config = {
  env: 'live',
  dev: {
    url: 'https://onepay.dev.pannovate.com/api/'
  },
  live: {
    url: 'https://onepay.stage.pannovate.com/api/'
  }
}

export default config;



// WEBPACK FOOTER //
// ./src/config/config.js